export default __webpack_public_path__ + "static/media/payment-out.f7ca502c.svg";